import MeasurementService from '@/services/measurement'

export default {
  name: 'mainpage',
  created () {
    this.updateLastMeasurement()
    this.startRefreshTimer()
    this.startSinceTimer()

    MeasurementService.getMeasurements('co2').then(response => {
      this.chartCo2.series[0].data = response.data
    })

    MeasurementService.getMeasurements('temperature').then(response => {
      this.chartTemperature.series[0].data = response.data
    })
    MeasurementService.getMeasurements('humidity').then(response => {
      this.chartHumidity.series[0].data = response.data
    })
  },
  data () {
    return {
      illuminance: '',
      temperature: '',
      humidity: '',
      co2: '',
      since: '',

      chartTemperature: {
        title: {
          text: 'Temperature'
        },
        chart: {
          type: 'column'
        },
        xAxis: {
          type: 'datetime'
        },
        yAxis: {
          title: {
            text: 'Celsius'
          },
          opposite: false
        },
        plotOptions: {
          line: {
            enableMouseTracking: true
          }
        },
        series: [{
          name: 'Temperature',
          data: [0],
          showInLegend: false
        }]
      },
      chartCo2: {
        title: {
          text: 'Co2'
        },
        chart: {
          type: 'column'
        },
        pinchType: 'x',
        xAxis: {
          type: 'datetime'
        },
        yAxis: {
          title: {
            text: 'PPM'
          },
          plotLines: [{
            value: 1000,
            color: 'red',
            dashStyle: 'Solid',
            width: 2,
            zIndex: 99,
            label: {
              text: 'Ashrae Level'
            }
          }]
        },
        plotOptions: {
          line: {
            enableMouseTracking: true
          }
        },
        series: [{
          name: 'Co2',
          data: [0],
          showInLegend: false
        }]
      },
      chartHumidity: {
        title: {
          text: 'Humidity'
        },
        chart: {
          type: 'column'
        },
        xAxis: {
          type: 'datetime'
        },
        yAxis: {
          title: {
            text: 'Percentage'
          },
          opposite: false
        },
        plotOptions: {
          line: {
            enableMouseTracking: true
          }
        },
        series: [{
          name: 'Percentage',
          data: [0],
          showInLegend: false
        }]
      }
    }
  },
  methods: {
    updateLastMeasurement () {
      MeasurementService.getLastMeasurement().then(response => {
        this.illuminance = response.data.Ev
        this.temperature = response.data.T
        this.humidity = response.data.rh
        this.co2 = response.data.co2
        this.recorded = response.data.t
        this.since = this.updateSince()
      })
    },
    updateSince () {
      const now = Math.floor(Date.now() / 1000)
      const measuredDate = Math.floor(this.recorded / 1000)
      let elapsed = now - measuredDate
      if (elapsed < 0) {
        return 'right now'
      }
      let interval = Math.floor(elapsed / 31536000)
      if (interval >= 1) {
        return interval + ' years'
      }
      interval = Math.floor(elapsed / 2592000)
      if (interval >= 1) {
        return interval + ' months'
      }
      interval = Math.floor(elapsed / 86400)
      if (interval >= 1) {
        return interval + ' days'
      }
      interval = Math.floor(elapsed / 3600)
      if (interval >= 1) {
        return interval + ' hours'
      }
      interval = Math.floor(elapsed / 60)
      if (interval >= 1) {
        return interval + ' minutes'
      }
      return elapsed + ' seconds'
    },
    startRefreshTimer () {
      window.setInterval(() => {
        this.since = this.updateLastMeasurement()
      }, 30000)
    },
    startSinceTimer () {
      window.setInterval(() => {
        this.since = this.updateSince()
      }, 5000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mainpage/script.js